import React, { useContext, useState } from 'react'
import { ContextGloball } from '../Context/ContextGlobal';
import valPer from '../Tools/VerificarPermisos';
import GraficaTipoPedido from './GraficaTipoPedido';
import ControlMotosPrincipal from './ControlMotosPrincipal';
import PrincipalSugerencias from '../Sugerencias/PrincipalSugerencias';
import AlmacenRegional from './AlmacenRegional';
import HistoricoVnetas from './HistoricoVnetas';
import PrincipalContaduria from '../Contaduria/PrincipalContaduria';
import CantidadVentas from './CantidadVentas';
import OrdenesProduccion from './OrdenesProduccion';
import ReportePollosAlmacenes from './ReportePollosAlmacenes';
import InterfazTemperatura from './InterfazTemperatura';
function MenuReportes() {
    const { ventana, setVentana, setTitulo } = useContext(ContextGloball);
    const [subVentana, setSubVentana] = useState(0);
    const validarVentana = (item) => {
        var cls = subVentana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    function mostrarSubventana() {
        if (subVentana == 1) {
            return (<GraficaTipoPedido />)
        } else if (subVentana == 2) {
            return (<ControlMotosPrincipal />)
        } else if (subVentana == 3) {
            return (<PrincipalSugerencias />)
        } else if (subVentana == 4) {
            return (<AlmacenRegional />)
        } else if (subVentana == 5) {
            return (<HistoricoVnetas />)
        } else if (subVentana == 6) {
            return (<PrincipalContaduria />)
        } else if (subVentana == 7) {
            return (<CantidadVentas />)
        } else if (subVentana == 8) {
            return (<OrdenesProduccion />)
        } else if (subVentana == 9) {
            return (<ReportePollosAlmacenes />)
        } else if (subVentana == 10) {
            return (<InterfazTemperatura />)
        }

    }
    return (
        <>
            {subVentana == 0 && <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {valPer.validarPermiso('18') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(1)}`}
                                onClick={() => { setSubVentana(1); setTitulo("Tipo de pedido"); }}>
                                <i className="fa-solid fa-chart-simple"></i><span className=""> Tipo Pedidos</span></a>
                        </div>}
                    {valPer.validarPermiso('19') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(2)}`}
                                onClick={() => { setSubVentana(2); setTitulo('Control de Motos') }}>
                                <i className="fa-solid fa-motorcycle"></i><span className=""> Motos</span></a>
                        </div>}
                    {valPer.validarPermiso('27') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(3)}`}
                                onClick={() => { setSubVentana(3); setTitulo('Reporte Quejas') }}>
                                <i className="fa-solid fa-clipboard"></i><span className=""> Quejas Sugerencias</span></a>
                        </div>}
                    {valPer.validarPermiso('29') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(4)}`}
                                onClick={() => { setSubVentana(4); setTitulo('Almacen Regional Planta') }}>
                                <i className="fa-solid fa-cube"></i><span className=""> Planta regional</span></a>
                        </div>}
                    {valPer.validarPermiso('39') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(5)}`}
                                onClick={() => { setSubVentana(5); setTitulo('Historico de Ventas') }}>
                                <i className="fa-solid fa-store"></i><span className=""> Historico Ventas</span></a>
                        </div>}
                    {valPer.validarPermiso('46') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(6)}`}
                                onClick={() => { setSubVentana(6); setTitulo('NIT Observados'); }}>
                                <i className="fa-solid fa-cash-register"></i><span className="ms-1 "> NIT Observados</span></a>
                        </div>}
                    {valPer.validarPermiso('8') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(7)}`}
                                onClick={() => { setSubVentana(7); setTitulo('Cantidad de Ventas'); }}>
                                <i className="fa-solid fa-boxes-stacked"></i><span className="ms-1 "> Cantidad Ventas</span></a>
                        </div>}
                    {valPer.validarPermiso('68') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(8)}`}
                                onClick={() => { setSubVentana(8); setTitulo('Orden Producción'); }}>
                                <i className="fa-solid fa-ranking-star"></i><span className="ms-1 "> Orden Producción</span></a>
                        </div>}
                    {valPer.validarPermiso('69') &&
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(9)}`}
                                onClick={() => { setSubVentana(9); setTitulo('Reporte de Pollo (Almacenes)'); }}>
                                <i className="fa-solid fa-boxes-stacked"></i><span className="ms-1 "> Reporte de Pollo (Almacenes)</span></a>
                        </div>}

                    {
                        <div className='col col-sm-6 col-md-4'>
                            <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(9)}`}
                                onClick={() => { setSubVentana(10); setTitulo('Interfaz de Temperatura'); }}>
                                <i className="fa-solid fa-temperature-low"></i><span className="ms-1 "> Interfaz de Temperatura</span></a>
                        </div>}

                </div>
            </div>}
            {mostrarSubventana()}
            {subVentana !== 0 && <button className='btn text-danger btn-flotante' onClick={() => { setTitulo('Reportes'); setSubVentana(0) }}><i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
        </>
    )
}

export default MenuReportes